module.exports = __webpack_public_path__ + "img/help.8d28949a.png";